"use strict";
/**
 * Created by Mike Naughton on 3/20/18.
 *
 * evented decorator based on https://stackoverflow.com/questions/37333323/how-can-i-extend-backbone-events-in-a-typescript-es6-class?rq=1
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Backbone = require("backbone");
var _ = require("underscore");
var Evented = /** @class */ (function () {
    function Evented() {
        _.extend(this, Backbone.Events);
    }
    Evented.prototype.on = function (eventName, callback, context) {
        return this;
    };
    Evented.prototype.off = function (eventName, callback, context) {
        return this;
    };
    Evented.prototype.trigger = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return this;
    };
    Evented.prototype.bind = function (eventName, callback, context) {
        return this;
    };
    Evented.prototype.unbind = function (eventName, callback, context) {
        return this;
    };
    Evented.prototype.once = function (events, callback, context) {
        return this;
    };
    Evented.prototype.listenTo = function (object, events, callback) {
        return this;
    };
    Evented.prototype.listenToOnce = function (object, events, callback) {
        return this;
    };
    Evented.prototype.stopListening = function (object, events, callback) {
        return this;
    };
    return Evented;
}());
exports.default = Evented;
//# sourceMappingURL=Evented.js.map


//////////////////
// WEBPACK FOOTER
// ./public/js/core/Evented.js
// module id = 663
// module chunks = 1